/**
 * Exporta dados para um arquivo CSV e dispara o download no browser.
 *
 * @param {string} filename - Nome do arquivo (ex: 'emendas.csv')
 * @param {string[]} headers - Cabeçalhos das colunas
 * @param {Array<Array<any>>} rows - Linhas de dados
 */
export function exportToCsv(filename, headers, rows) {
  const separator = ';';
  const escape = (val) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    // Envolve em aspas se tiver separador, aspas ou quebra de linha
    return str.includes(separator) || str.includes('"') || str.includes('\n')
      ? `"${str.replace(/"/g, '""')}"`
      : str;
  };

  const lines = [
    headers.map(escape).join(separator),
    ...rows.map((row) => row.map(escape).join(separator)),
  ];

  // BOM (\uFEFF) garante que o Excel abra com acentos corretamente
  const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Exporta um objeto `report` (formato usado pelo ReportTable) para CSV.
 * report = { config: { columns: [{ key, name, displayable }] }, data: [[...]] }
 *
 * @param {string} filename
 * @param {object} report
 */
export function exportReportToCsv(filename, report) {
  if (!report) return;

  const displayableCols = report.config.columns
    .map((col, index) => ({ ...col, index }))
    .filter((col) => col.displayable);

  const headers = displayableCols.map((col) => col.name);
  const rows = report.data.map((row) => displayableCols.map((col) => row[col.index]));

  exportToCsv(filename, headers, rows);
}

export function exportToTxt(filename, headers, rows) {
  const clean = (val) => {
    if (val === null || val === undefined) return '';
    return String(val).replace(/\t/g, ' ').replace(/\n/g, ' ');
  };

  const lines = [
    headers.map(clean).join('\t'),
    ...rows.map((row) => row.map(clean).join('\t')),
  ];

  const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/plain;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function exportReportToTxt(filename, report) {
  if (!report) return;

  const displayableCols = report.config.columns
    .map((col, index) => ({ ...col, index }))
    .filter((col) => col.displayable);

  const headers = displayableCols.map((col) => col.name);
  const rows = report.data.map((row) => displayableCols.map((col) => row[col.index]));

  exportToTxt(filename, headers, rows);
}
